import { render } from "./GoalActivityPanel.vue?vue&type=template&id=ff72ea44"
import script from "./GoalActivityPanel.vue?vue&type=script&lang=js"
export * from "./GoalActivityPanel.vue?vue&type=script&lang=js"
script.render = render

export default script